import { render, staticRenderFns } from "./timDec.vue?vue&type=template&id=39f75a76&scoped=true"
import script from "./timDec.vue?vue&type=script&lang=js"
export * from "./timDec.vue?vue&type=script&lang=js"
import style0 from "./timDec.vue?vue&type=style&index=0&id=39f75a76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f75a76",
  null
  
)

export default component.exports